import React from 'react';
import { Button } from './ui/Button';
import { HeroCanvas } from './HeroCanvas';
import { HeadingAccent } from './ui/HeadingAccent';
import { ArrowRight, Calendar } from 'lucide-react';
import { useSiteContent } from '../contexts/SiteContentContext';
interface HeroProps {
  onExploreClick?: () => void;
  onBookClick?: () => void;
  onClassesClick?: () => void;
}
export function Hero({
  onExploreClick,
  onBookClick,
  onClassesClick
}: HeroProps) {
  const {
    content
  } = useSiteContent();
  const heroContent = content.hero;
  return <section id="inicio" className="min-h-screen flex flex-col items-center justify-center pt-[140px] md:pt-[160px] pb-16 md:pb-20 px-4 md:px-16 gap-8 md:gap-16 relative overflow-hidden" data-id="element-1074">
      {/* Background Gradients */}
      <div className="absolute inset-0 z-0 pointer-events-none" data-id="element-1075">
        <div className="absolute top-[10%] right-[10%] w-[60%] h-[60%] bg-sage/10 rounded-full blur-[100px]" data-id="element-1076" />
        <div className="absolute bottom-[10%] left-[10%] w-[50%] h-[50%] bg-sand/80 rounded-full blur-[100px]" data-id="element-1077" />
      </div>

      <div className="relative z-10 flex flex-col items-center text-center max-w-3xl mx-auto" data-id="element-1078">
        <h1 className="font-display text-4xl sm:text-5xl md:text-6xl lg:text-[4.5rem] leading-[1.1] text-earth mb-4 md:mb-6 font-[600]" data-id="element-1079">
          <span className="block animate-fade-slide-up [animation-delay:100ms]" data-id="element-1080">
            {heroContent.heading1}
          </span>
          <span className="block animate-fade-slide-up [animation-delay:200ms]" data-id="element-1081">
            <HeadingAccent data-id="element-1082">{heroContent.heading2}</HeadingAccent>
          </span>
        </h1>

        <p className="text-base md:text-lg text-stone leading-relaxed mb-8 md:mb-10 max-w-[480px] animate-fade-slide-up [animation-delay:200ms] px-2" data-id="element-1083">
          {heroContent.subtitle}
        </p>

        <div className="mb-8 md:mb-10 animate-fade-slide-up [animation-delay:250ms] w-full flex justify-center px-4" data-id="element-1084">
          <HeroCanvas data-id="element-1085" />
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4 w-full sm:w-auto px-4 animate-fade-slide-up [animation-delay:300ms]" data-id="element-1086">
          <Button size="lg" onClick={onBookClick} className="w-full sm:w-auto" data-id="element-1087">
            <Calendar size={20} data-id="element-1088" />
            {heroContent.ctaBook}
          </Button>
          <Button variant="outline" size="lg" onClick={onClassesClick} className="w-full sm:w-auto" data-id="element-1089">
            {heroContent.ctaClasses}
            <ArrowRight size={20} data-id="element-1090" />
          </Button>
        </div>
      </div>
    </section>;
}